export const FormatOptionsModal: string = 'FormatOptionsModal';
